"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripDriver = void 0;
class TripDriver {
    _id;
    displayName;
    vehicle;
    phoneNumber;
    profilePhotoUrl;
    constructor(init) {
        Object.assign(this, init);
    }
}
exports.TripDriver = TripDriver;
//# sourceMappingURL=TripDriver.js.map